import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Wind, LogOut, User } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const dashPath =
    user?.role === "admin" ? "/dashboard/admin" :
    user?.role === "partner" ? "/dashboard/partner" :
    "/dashboard/customer";

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-white/80 backdrop-blur-xl">
      <div className="mx-auto max-w-7xl px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2.5 group">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-primary to-cyan-400 flex items-center justify-center shadow-md shadow-primary/25 group-hover:shadow-primary/40 transition-shadow duration-200">
            <Wind className="w-5 h-5 text-white" />
          </div>
          <span className="font-display font-black text-xl tracking-tight">VayuCheck</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <Link to="/partners" data-testid="nav-partners" className="text-muted-foreground hover:text-foreground transition-colors duration-200">Find Centers</Link>
          <Link to="/book" data-testid="nav-book" className="text-muted-foreground hover:text-foreground transition-colors duration-200">Book PUC</Link>
          <Link to="/register/commercial" data-testid="nav-fleets" className="text-muted-foreground hover:text-foreground transition-colors duration-200">For Fleets</Link>
          <Link to="/about" data-testid="nav-about" className="text-muted-foreground hover:text-foreground transition-colors duration-200">About</Link>
          <Link to="/faqs" data-testid="nav-faqs" className="text-muted-foreground hover:text-foreground transition-colors duration-200">FAQs</Link>
          <Link to="/contact" data-testid="nav-contact" className="text-muted-foreground hover:text-foreground transition-colors duration-200">Contact</Link>
          {user?.role === "admin" && <Link to="/dashboard/admin" data-testid="nav-admin" className="text-muted-foreground hover:text-foreground transition-colors duration-200">Admin</Link>}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Link to={dashPath} data-testid="nav-dashboard" className="flex items-center gap-2 text-sm text-foreground hover:text-primary transition-colors duration-200">
                <User className="w-4 h-4" /> {user.name?.split(" ")[0] || "Account"}
              </Link>
              <Button data-testid="nav-logout" variant="ghost" size="sm" onClick={handleLogout} className="rounded-full hover:bg-secondary">
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login">
                <Button variant="ghost" size="sm" className="rounded-full text-foreground hover:bg-secondary">Login</Button>
              </Link>
              <Link to="/register" data-testid="nav-register">
                <Button size="sm" className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 font-semibold shadow-md shadow-primary/25">Get Started</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
